import React from "react";
import addClass from "./add-class";

type TOptionProps = {
    /** The value sent to the parent Combobox's `onSelect` handler. */
    value: any;
    /** What to put in the input when this option is selected; defaults to its children. */
    label?: string;
    /** Strings, not booleans — Combobox reads these off the un-rendered element. */
    isfocusable?: string;
    isselected?: string | boolean;
    children?: React.ReactNode;
    // Everything else is spread onto the rendered <div>, including the handlers
    // Combobox injects via cloneElement (onBlur/onClick/onFocus/onKeyDown/onMouseEnter).
} & React.HTMLAttributes<HTMLDivElement>;

const Option = (ownProps: TOptionProps) => {
    const props: any = { ...ownProps };
    if (props.isselected === "true") {
        props.className = addClass(props.className, "ic-tokeninput-selected");
        props.ariaSelected = true;
    }
    return <div {...props} />;
};

// Kept as defaultProps rather than destructured defaults on purpose: Combobox
// inspects `child.props` on the un-rendered element (see makeMenu in combobox.tsx),
// which only sees defaults that React resolves at createElement time.
Option.defaultProps = {
    role: "option",
    tabIndex: "-1",
    className: "ic-tokeninput-option",
    isselected: false,
    isfocusable: "true",
};

export default Option;
